import { ReminderActionType } from 'src/app/models/RestApiCaller/Enums/reminder-action-type';
import { BaseActionData } from './base-action-data';
import { WorkflowActionTypes } from 'src/app/models/RestApiCaller/Enums/workflow-action-types';
import { DateReferences } from 'src/app/models/enums/date-references';

/**
 * Représente les données d'une action 'Création de rappel'.
 */
export class ReminderCreationActionData extends BaseActionData {
    /**
     * Date de réference du délai.
     */
    public dateReference?: DateReferences;

    /**
     * Délai en minutes.
     */
    public delay?: number;

    /**
     * Id de l'attribut contenant la date de reference.
     */
    public dateAttributeId?: number;

    /**
     * Obtient ou défini la date de la prochaine occurence du rappel (si null, ne se produit qu'une seule fois).
     */
    public occurenceFrequency?: number;

    /**
     * Obtient ou défini le nombre d'occurences maximum du rappel (si null, le rappel n'a pas de fin tant qu'il n'est pas supprimé.).
     */
    public maxOccurence?: number;

    /**
     * Obtient ou défini l'id du type d'action déclenché par ce rappel.
     */
    public actionType: ReminderActionType;

    /**
     * Obtient ou défini les données de l'action déclenché par ce rappel.
     * Les données sont stockées au format JSON.
     */
    public actionData: string;

    /**
     * Constructeur.
     */
    constructor() {
        super(WorkflowActionTypes.ReminderCreation);
    }

    /**
     * Retourne une copie d'une instance de ReminderCreationActionData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: ReminderCreationActionData) {
        if (!!other) {
            const instance = new ReminderCreationActionData();
            instance.dateReference = other.dateReference;
            instance.delay = other.delay;
            instance.dateAttributeId = other.dateAttributeId;
            instance.occurenceFrequency = other.occurenceFrequency;
            instance.maxOccurence = other.maxOccurence;
            instance.actionType = other.actionType;
            instance.actionData = other.actionData;

            return instance;
        } else {
            return null;
        }
    }
}
